
export default function Products() {
  const sesameProducts = [
    { size: '50ml', originalPrice: '35,000원', salePrice: '28,000원' },
    { size: '100ml', originalPrice: '55,000원', salePrice: '44,000원' },
    { size: '180ml', originalPrice: '99,000원', salePrice: '79,200원' }
  ];

  const perillaProducts = [
    { size: '50ml', originalPrice: '24,000원', salePrice: '19,200원' },
    { size: '100ml', originalPrice: '39,000원', salePrice: '31,200원' },
    { size: '180ml', originalPrice: '69,000원', salePrice: '55,200원' }
  ];

  const ProductCard = ({ title, products, image, icon, gradient }: any) => (
    <div className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300" data-product-shop>
      <div className={`h-64 bg-gradient-to-br ${gradient} p-8 relative overflow-hidden`}>
        <div className="absolute top-4 right-4">
          <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
            <i className={`${icon} text-white text-2xl`}></i>
          </div>
        </div>
        <img 
          src={image}
          alt={title}
          className="w-full h-full object-contain drop-shadow-2xl"
        />
      </div>
      
      <div className="p-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">{title}</h3>
        
        <div className="space-y-4">
          {products.map((product: any, index: number) => (
            <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-2xl hover:bg-gray-100 transition-colors">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-amber-500 to-orange-500 rounded-full text-white font-bold">
                  {product.size}
                </div>
                <div>
                  <p className="text-gray-500 line-through text-sm">{product.originalPrice}</p>
                  <p className="text-2xl font-bold text-red-600">{product.salePrice}</p>
                </div>
              </div>
              <button className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-3 rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-shopping-cart-line mr-2"></i>주문
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <section id="products" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            프리미엄 제품 라인업
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            국내산 최고급 원료만을 사용하여 저온 압착 방식으로 영양소 파괴를 최소화한 
            노원장만의 특별한 기름을 만나보세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <ProductCard
            title="노원장 하이엔드 국산100% 참기름"
            products={sesameProducts}
            image="https://static.readdy.ai/image/ce2a556e276a3afd2385ae1ca37a15ee/f5b4bc70cd98e5246b08e4ff6fca0666.jfif"
            icon="ri-leaf-fill"
            gradient="from-amber-400 to-yellow-500"
          />
          
          <ProductCard
            title="노원장 하이엔드 국산100% 들기름"
            products={perillaProducts}
            image="https://static.readdy.ai/image/ce2a556e276a3afd2385ae1ca37a15ee/487b78825d0a6a7a9c44a29cc1132f23.jfif"
            icon="ri-plant-fill"
            gradient="from-emerald-400 to-green-500"
          />
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 rounded-3xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-red-700 mb-4">
              ⚠️ 수량 한정! 조기 마감 예상
            </h3>
            <p className="text-red-600 text-lg mb-6">
              최고급 원료의 한정적 수급으로 인해 수량이 많지 않습니다.<br/>
              소중한 분들께 선물하실 계획이시라면 지금 바로 주문해주세요.
            </p>
            <button className="bg-gradient-to-r from-red-500 to-orange-500 text-white px-12 py-4 rounded-full hover:shadow-lg transition-all text-xl font-bold whitespace-nowrap cursor-pointer">
              <i className="ri-time-line mr-2"></i>지금 바로 주문하기
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
